module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotTemplateSlotDetails) ? _c('b-modal', {
    ref: "missionSlotTemplateSlotDetailsModal",
    attrs: {
      "id": "missionSlotTemplateSlotDetailsModal",
      "size": "lg",
      "title": _vm.slotDetailsTitle,
      "no-close-on-backdrop": ""
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-1"
  }, [_vm._v("#")]), _vm._v(" "), _c('div', {
    staticClass: "col col-6"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.role')))]), _vm._v(" "), _c('div', {
    staticClass: "col col-5"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.difficulty')))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-1"
  }, [_vm._v(_vm._s(_vm.missionSlotTemplateSlotDetails.orderNumber))]), _vm._v(" "), _c('div', {
    staticClass: "col col-6"
  }, [_vm._v(_vm._s(_vm.missionSlotTemplateSlotDetails.title) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "col col-5"
  }, [_c('i', {
    class: _vm.difficultyIcon,
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.difficultyColor
  }, [_vm._v(_vm._s(_vm.difficultyText))])])]), _vm._v(" "), _c('div', {
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col col-6"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.description')))]), _vm._v(" "), _c('div', {
    staticClass: "col col-5"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.status')))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col col-6"
  }, [_vm._v(_vm._s(_vm.missionSlotTemplateSlotDetails.description))]), _vm._v(" "), _c('div', {
    staticClass: "col col-5",
    domProps: {
      "innerHTML": _vm._s(_vm.slotStatus)
    }
  })]), _vm._v(" "), _c('hr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionSlotTemplateSlotDetails.detailedDescription),
      expression: "missionSlotTemplateSlotDetails.detailedDescription"
    }],
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionSlotTemplateSlotDetails.detailedDescription),
      expression: "missionSlotTemplateSlotDetails.detailedDescription"
    }],
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.detailedDescription')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionSlotTemplateSlotDetails.detailedDescription),
      expression: "missionSlotTemplateSlotDetails.detailedDescription"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12",
    domProps: {
      "innerHTML": _vm._s(_vm.missionSlotTemplateSlotDetails.detailedDescription)
    }
  })])]), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [(_vm.isMissionSlotTemplateCreator) ? _c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.duplicateMissionSlotTemplateSlot
    }
  }, [_c('i', {
    staticClass: "fa fa-files-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.duplicate.mission.slot')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isMissionSlotTemplateCreator) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotTemplateSlotEditModal",
      modifiers: {
        "missionSlotTemplateSlotEditModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.hideMissionSlotTemplateSlotDetailsModal
    }
  }, [_c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotTemplateSlotDetailsModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.close')) + "\n      ")])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-356e95f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missionSlotTemplates/modals/MissionSlotTemplateSlotDetailsModal.vue
// module id = 495
// module chunks = 0